/*========================================================================
* $Id: search.js 86378 2015-09-10 09:02:14Z michael.biebl $
*
* Copyright © Mindbreeze Software GmbH, Linz, Austria, 2005-2013
*
* Der Nutzer des Computerprogramms anerkennt, dass der oben stehende
* Copyright-Vermerk im Sinn des Welturheberrechtsabkommens an der vom
* Urheber festgelegten Stelle in der Funktion des Computerprogramms
* angebracht bleibt, um den Vorbehalt des Urheberrechtes genuegend zum
* Ausdruck zu bringen. Dieser Urheberrechtsvermerk darf weder vom Kunden,
* Nutzer und/oder von Dritten entfernt, veraendert oder disloziert werden.
* =========================================================================*/
define(
  [
    "client/templateregistry",
    "component!base",
    "component!row",
    "component!searchroot",
    "client/template",
    "client/templatetree",
    "api/v2/api",
    "i18n/i18n",
    "utils/clone",
    "utils/accessibility",
    "underscore",
    "jquery",
    "utils/dom",
    "backbone"
  ],
  function (
    TemplateRegistry,
    Base,
    Row,
    SearchRootTemplate,
    Template,
    TemplateTree,
    api,
    i18n,
    clone,
    Accessibility,
    _,
    $,
    dom,
    Backbone
  ) {

    var SearchTemplate = Template.extend({

      initialize: function () {
        Template.prototype.initialize.apply(this, _.toArray(arguments));
        this.$el = $(this.el);
      },

        editableName: "editor_searchcontainer",

        schema: new Template.Schema({
            attributes: {
            }
        }),

        remove: function (options) {
          _.forEach(this.instances, function (view) {
            view.remove();
          });
          this.instances = [];
          var nodeChildren = options && options.node && options.node.children;
          _.forEach(nodeChildren, function (childNode) {
            childNode.template.remove({
              node: childNode
            });
          });
        },

        hasContent: function () {
          return true;
        },

        getContentSchema: function() {
          return  {
            type: "template"
          };
        },

        getContent: function() {
          return this.children[0].template;
        },

        getDefaultTemplateAsEl: function() {
          var html = this.getDefaultTemplate();
          if (html) {
            return dom.instantiate(html);
          }
        },

        getDefaultTemplate: function() {
          return '\
          <div data-template="search" data-name="searchcontainer" data-count="5" data-inherit-constraints-from-parent="true" data-constraint="ALL">\
            <div data-template="view" data-searchcontainer-view>\
              <div class="mb-component-container">\
              </div>\
            </div>\
          </div>';
        }
    });

    SearchTemplate.View = Base.extend({});

    TemplateRegistry.add({
      id: "searchcontainer_designer",
      name: "editor_searchcontainer",
      weight: 7,

      getAdders: function (context) {
        return [{
            name: "editor_searchcontainer",
            icon: "../img/imgsearchcontainer.png",
            group: {
              name: "editor_searchcontainer"
            },
            options: {
              template: "searchdesigner",
              count: 5
            },
        }]
        
      },
      create: function (options) {
        options = options || {};
        options.template = options.template;

        var el = document.createElement("div");
        el.className = 'searchdesigner-container';
        el.setAttribute("data-template", "searchdesigner");
        return el;
      }

    });

    return SearchTemplate;
  }
);
